export default "__VITE_ASSET__CqkcyZTY__"